import changePasswordSlice from "./changePasswordSlice";

export const changePasswordReducers = {
  changePasswordSlice,
};
